import { render, staticRenderFns } from "./historyorder.vue?vue&type=template&id=fef11316&scoped=true"
import script from "./historyorder.vue?vue&type=script&lang=js"
export * from "./historyorder.vue?vue&type=script&lang=js"
import style0 from "./historyorder.vue?vue&type=style&index=0&id=fef11316&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef11316",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fef11316')) {
      api.createRecord('fef11316', component.options)
    } else {
      api.reload('fef11316', component.options)
    }
    module.hot.accept("./historyorder.vue?vue&type=template&id=fef11316&scoped=true", function () {
      api.rerender('fef11316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/historyorder.vue"
export default component.exports